import React, { forwardRef } from 'react';
import clsx from 'clsx';
import { Box } from '../Box';
import { responsiveCssProperties, useResponsiveProp } from '../../utils';
import { textComponentFactory } from './TextUtils';
import './Text.css';
const TextComponent = forwardRef(function Text(props, ref) {
    const { children, ...propsExChildren } = props;
    const { elementType = 'p', variant, color, fontFamily, fontSize, fontWeight, fontStyle, fontVariant, letterSpacing, lineHeight, textAlign, textTransform, textDecoration, textOverflow, whiteSpace, className, style, ...rest } = propsExChildren;
    const responsiveTextOverflow = useResponsiveProp(textOverflow);
    const responsiveVariant = useResponsiveProp(variant);
    if (Object.keys(propsExChildren).length === 0) {
        return React.createElement(React.Fragment, null, children);
    }
    return (React.createElement(Box.Restricted, { ...rest, elementType: elementType, className: clsx('mollie-ui-text', {
            [`mollie-ui-typography-${responsiveVariant}`]: responsiveVariant,
            'mollie-ui-text--overflow': responsiveTextOverflow,
        }, className), style: {
            ...style,
            ...responsiveCssProperties({
                '--mollie-ui-text-color': color,
                '--mollie-ui-text-font-family': fontFamily,
                '--mollie-ui-text-font-size': fontSize,
                '--mollie-ui-text-font-weight': fontWeight,
                '--mollie-ui-text-font-style': fontStyle,
                '--mollie-ui-text-font-variant': fontVariant,
                '--mollie-ui-text-letter-spacing': letterSpacing,
                '--mollie-ui-text-line-height': lineHeight,
                '--mollie-ui-text-align': textAlign,
                '--mollie-ui-text-transform': textTransform,
                '--mollie-ui-text-decoration': textDecoration,
                '--mollie-ui-text-white-space': whiteSpace,
            }),
        }, ref: ref }, children));
});
const createTextComponent = textComponentFactory(TextComponent);
TextComponent.displayName = 'Text';
export const Text = Object.assign({}, TextComponent, {
    H1: createTextComponent('h1', { variant: 'heading-title-1' }),
    H2: createTextComponent('h2', { variant: 'heading-title-2' }),
    H3: createTextComponent('h3', { variant: 'heading-title-3' }),
    H4: createTextComponent('h4', { variant: 'heading-title-4' }),
    H5: createTextComponent('h5', { variant: 'subtitle-semi-bold' }),
    H6: createTextComponent('h6', { variant: 'subtitle-regular' }),
    P: createTextComponent('p', { variant: 'body-regular' }),
    Em: createTextComponent('em', { fontStyle: 'italic' }),
    Strong: createTextComponent('strong', { fontWeight: 'semi-bold' }),
    Span: createTextComponent('span'),
    Pre: createTextComponent('pre', { variant: 'code-regular' }),
    Code: createTextComponent('code', { fontFamily: 'code' }),
});
//# sourceMappingURL=Text.js.map